export default "__VITE_ASSET__5e0c04c8__"